<template>
  <div id="app">
    <div class="container">
      <div class="content">
        <div class="top-pic">
          <img src="../../assets/img/top.png" />
        </div>
        <div class="linehead">
          <div class="trademark">
            <img src="../../assets/img/logo1.png" />
          </div>
          <div class="trademark1">
            <img src="../../assets/img/logo2.png" />
          </div>
          <div class="trademark2">
            <img src="../../assets/img/logo3.jpg" />
          </div>
          <div class="trademark3">
            <img src="../../assets/img/logo4.jpg" />
          </div>
          <div class="trademark4">
            <img src="../../assets/img/logo5.png" />
          </div>
          <div class="trademark5">
            <img src="../../assets/img/logo6.png" />
          </div>
          <div class="welcome" v-if="this.$store.state.num == 2">
            <span class="you">兴文世界地质公园欢迎您！</span>
            <div>
              <lunar></lunar>
            </div>
          </div>
          <div class="welcome" v-else>
            <span class="you">Welcome to Xingwen UNESCO Global Geopark.</span>
            <div>
              <lunar></lunar>
            </div>
          </div>

          <!-- <span class="manager">
            <a href="http://admin.xw-sjdzgy.com"> 后台 </a>
          </span> -->
        </div>
        <div class="navigation">
          <router-link to="/search">
            <span class="navigation-bar" v-if="this.$store.state.num == 2"> 首页 </span>
            <span class="navigation-bar" v-else> Home </span>
          </router-link>
          <router-link to="/information">
            <span class="navigation-bar" v-if="this.$store.state.num == 2"> 公园简介 </span>
            <span class="navigation-bar" v-else> About </span>
          </router-link>
          <router-link to="/newscenter">
            <span class="navigation-bar" v-if="this.$store.state.num == 2"> 新闻中心 </span>
            <span class="navigation-bar" v-else> News </span>
          </router-link>
          <router-link to="/resourcepro">
            <span class="navigation-bar" v-if="this.$store.state.num == 2"> 资源保护 </span>
            <span class="navigation-bar" v-else> Resources </span>
          </router-link>
          <router-link to="/teach">
            <span class="navigation-bar" v-if="this.$store.state.num == 2"> 科普教育 </span>
            <span class="navigation-bar" v-else> Education </span>
          </router-link>
          <router-link to="/travel">
            <span class="navigation-bar" v-if="this.$store.state.num == 2"> 地质旅游 </span>
            <span class="navigation-bar" v-else> Tourism </span>
          </router-link>
          <router-link to="/sisterpark">
            <span class="navigation-bar" v-if="this.$store.state.num == 2"> 合作伙伴 </span>
            <span class="navigation-bar" v-else> Partners </span>
          </router-link>
          <router-link to="/download">
            <span class="navigation-bar" v-if="this.$store.state.num == 2" @click=open()> 下载中心 </span>
            <span class="navigation-bar" v-else> Downloads </span>
          </router-link>
        </div>
        <div>
          <router-view />
        </div>
        <!-- 中英文版本 -->
        <div class="buttom" v-if="this.$store.state.num == 2 || this.$store.state.num == null">
          <div class="buttom-box">
            <div class="buttom-info" style="width:220px">
              <span class="key">{{ address.name }}:</span>
              <span class="value">{{ address.value }}</span>
            </div>
            <div class="buttom-info" style="width:180px">
              <span class="key">{{ phone.name }}:</span>
              <span class="value">{{ phone.value }}</span>
            </div>
            <div class="buttom-info" style="width:200px">
              <span class="key">{{ email.name }}:</span>
              <span class="value">{{ email.value }}</span>
            </div>
            <div class="buttom-info" style="width:220px">
              <span class="key">{{ pub.name }}:</span>
              <span class="value">{{ pub.value }}</span>
            </div>
            <div class="buttom-info" style="width:200px">
              <span class="key">{{ icp.name }}:</span>
              <a href="https://beian.miit.gov.cn/">
                <span class="value">{{ icp.value }}</span>
              </a>
            </div>
            <div class="buttom-record" style="width:200px">
              <div>
                <img src="../../assets/img/record-num.png" />
              </div>
              <div class="buttom-info">
                <span class="key">{{ record.name }}:</span>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=5115280200071">
                  <span class="value">{{ record.value }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="buttom" v-else>
          <div class="buttom-box">
            <div class="buttom-info" style="width:220px">
              <span class="key">{{ address.nameEn }}:</span>
              <span class="value">{{ address.valueEn }}</span>
            </div>
            <div class="buttom-info" style="width:180px">
              <span class="key">{{ phone.nameEn }}:</span>
              <span class="value">{{ phone.valueEn }}</span>
            </div>
            <div class="buttom-info" style="width:200px">
              <span class="key">{{ email.nameEn }}:</span>
              <span class="value">{{ email.valueEn }}</span>
            </div>
            <div class="buttom-info" style="width:220px">
              <span class="key">{{ pub.nameEn }}:</span>
              <span class="value">{{ pub.valueEn }}</span>
            </div>
            <div class="buttom-info" style="width:200px">
              <span class="key">{{ icp.nameEn }}:</span>
              <a href="https://beian.miit.gov.cn/">
                <span class="value">{{ icp.valueEn }}</span>
              </a>
            </div>
            <div class="buttom-record" style="width:200px">
              <div>
                <img src="../../assets/img/record-num.png" />
              </div>
              <div class="buttom-info">
                <span class="key">{{ record.nameEn }}:</span>
                <a href="https://beian.miit.gov.cn/">
                  <span class="value">{{ record.valueEn }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- 中英文版本 -->

      </div>
    </div>
  </div>
</template>

<script>
import { info } from "../../api/api.js";
import lunar from "../../conponent/Lunar.vue";
export default {
  data() {
    return {
      carousel: {
        imgType: 0,
        column: "order_num",
        order: "desc",
      },
      address: "",
      phone: "",
      email: "",
      pub: "",
      icp: "",
      record: "",
    };
  },
  components: { lunar },
  created() {
    info(this.carousel).then((res) => {
      console.log(res.data.result[0])
      this.address = res.data.result[0];
      this.phone = res.data.result[1];
      this.email = res.data.result[2];
      this.pub = res.data.result[3];
      this.icp = res.data.result[4];
      this.record = res.data.result[5];
    });
  },
  methods: {
  }
};
</script>

<style scoped lang="less">
.container {
  background: url("../../assets/img/background.png");
  background-size: 100% 100%;
  min-height: 100vh;
}

.back-img {
  opacity: 0.5;
  position: absolute;
  z-index: 1;
  height: 157vh;
  width: 100%;
}

.back-img img {
  width: 100%;
  height: 100%;
}

.content {
  position: relative;
  z-index: 2;
  margin: 0 auto;
  width: 1200px;
  background: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.top-pic {
  height: 2vh;
  width: 100%;
}

.top-pic img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.linehead {
  width: 100%;
  height: 75px;
  background: rgb(240, 240, 239);
  display: flex;
  flex-direction: row;
  padding-left: 10px;
  padding-top: 10px;

  .trademark {
    width: 80px;
    height: 60px;
    z-index: 2;
  }

  .trademark1 {
    width: 70px;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  .trademark2 {
    width: 52px;
    height: 50px;
    z-index: 2;
    margin-left: 5px;
  }

  .trademark3 {
    width: 53x;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  .trademark4 {
    width: 55px;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  .trademark5 {
    width: 250px;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  img {
    height: 100%;
    width: 100%;
  }
}

.linehead .logo {
  width: 150px;
  height: 8vh;
  padding-top: 1vh;
}

.linehead .stone {
  margin-left: 10px;
  width: 200px;
  height: 5vh;
  font-size: 24px;
  padding-top: 15px;
}

.linehead .stone img {
  width: 100%;
  height: 80%;
}

.linehead .welcome {
  width: 570px;
  display: flex;
  flex-direction: column;
  font-weight: 600;
  height: 8vh;
  font-size: 20px;
  text-align: right;
}

.linehead .welcome .you {
  color: red;
}

.navigation {
  background: black;
  height: 4vh;
  width: 1200px;
  line-height: 4vh;
}

.navigation-bar {
  color: white;
  margin: 0 10px;
  font-size: 18px;
}

.buttom {
  height: 100px;
  // width: 100%;
  background: black;
  padding-top: 10px;
}

.buttom-box {
  width: 100%;
  display: flex;
  text-align: left;
  margin-left: 10px;
  padding: 10px;
}

.buttom-info {
  display: flex;
  flex-direction: column;
}

.buttom-info .key {
  color: red;
}

.buttom-info .value {
  color: white;
}

.manager {
  position: absolute;
  right: 20px;
  top: 70px;
}

.manager a {
  color: #666;
}

.buttom-record {
  display: flex;
  flex-direction: row;
}
</style>
